<section class="train-review-feedback" [attr.aria-label]="labels().title">
  <div class="train-review-feedback__grid">
    @for (option of options; track option.grade) {
      @if (isOptionVisible(option)) {
        <button
          type="button"
          class="btn train-review-feedback__button train-review-feedback__button--{{
            option.tone
          }}"
          [attr.data-testid]="'training-feedback-' + option.grade"
          [class.train-review-feedback__button--selected]="
            selectedReviewGrade() === option.grade
          "
          [disabled]="isBusy()"
          [attr.aria-label]="reviewButtonAriaLabel(option)"
          (click)="review.emit(option.grade)"
        >
          <svg class="train-review-feedback__icon sa-icon" aria-hidden="true">
            <use [attr.href]="'/assets/icons/sprite.svg#' + option.icon"></use>
          </svg>
          <span class="train-review-feedback__label">
            {{ labels()[option.labelKey] }}
          </span>
        </button>
      }
    }
  </div>
</section>
